import { config } from 'app-config';

export const getFieldMappingId = (journeyId: string) => {
  return `journey-${journeyId}`;
};

export const toFormUrl = (backendUrl: string) => {
  const path = new URL(backendUrl).pathname;
  return `${config.FORMS_URL}${path}`;
};
